import { Delete, Edit } from "@mui/icons-material";
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableRow,
} from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { DeleteModal, PopupModal } from "../../Components/Modal/Modals";
import {
    TableCellStyle,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import { apcReset, DeleteAPC } from "../../Redux/APCAdder/ApcAdderSlice";
import EditAPC from "./EditAPC";

const APCShow = ({ users }) => {
    const dispatch = useDispatch();
    const [data, setData] = useState({});
    //edit row
    const [edit, setEdit] = useState(false);
    const handelOpenEditRow = (data) => {
        setData(data);
        setEdit(true);
    };
    const handelCloseEditRow = () => {
        setData({});
        setEdit(false);
    };

    // Handle Delete Row
    const [del, setDel] = useState(false);

    const handleOpen = async (data) => {
        await setData(data);
        await setDel(true);
    };
    const handleClose = () => {
        setDel(false);
        setData({});
    };

    const CallNotificationMethod = async () => {
        await toast.success(" APC Adder Deleted Success");
        await dispatch(apcReset());
    };
    const DeleteRow = async () => {
        handleClose();
        await dispatch(DeleteAPC(data.adder_id));
        await CallNotificationMethod();
    };
    const handelDeleteAdder = async (data) => {
        handleOpen(data);
    };
    //edit row
    // const handelOpenDeleteRow = (data) => {
    //     setData(data);
    //     setDel(true);
    // };
    // const handelCloseDeleteRow = () => {
    //     setData({});
    //     setDel(false);
    // };

    return (
        <>
            <TableRowStyled>
                <TableCellStyle colSpan="4">
                    <Table>
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell> Member Name </TableCell>
                                <TableCell> Price </TableCell>
                                <TableCell> Price Type </TableCell>
                                <TableCell> Is Adder </TableCell>
                                <TableCell> Unit </TableCell>
                                <TableCell> Availability </TableCell>
                                <TableCell> Action </TableCell>
                            </TableRow>
                        </TableHeadStyled>
                        <TableBody>
                            {users.map((user, index) => (
                                <TableRowStyled key={user.id}>
                                    <TableCellStyle>{index + 1}</TableCellStyle>
                                    <TableCellStyle>
                                        {user?.email}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {user?.pivot.price}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {user?.pivot.price_type}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {user?.pivot.is_adder}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {user?.pivot.unit}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {user?.pivot.availability}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        <IconButton
                                            onClick={(e) =>
                                                handelOpenEditRow(user?.pivot)
                                            }
                                        >
                                            <Edit color="success" />
                                        </IconButton>
                                        <IconButton
                                            onClick={(e) =>
                                                handelDeleteAdder(user?.pivot)
                                            }
                                        >
                                            <Delete color="error" />
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>
                    </Table>
                </TableCellStyle>
                {/* EDIT MODAL  */}
                <PopupModal open={edit} close={handelCloseEditRow}>
                    <EditAPC data={data} />
                </PopupModal>
                {/* delete modal  */}
                <DeleteModal
                    open={del}
                    title="This Adder"
                    close={handleClose}
                    onClick={DeleteRow}
                />
            </TableRowStyled>
        </>
    );
};

export default APCShow;
